import Logo from 'components/Logo';

const Page = ({ children }) => (
  <div className="bg-gray-100">
    <main className="container mx-auto max-w-screen-md p-8 h-screen divide-y flex flex-col shadow bg-white overflow-scroll">
      <div className="">
        <Logo />
      </div>
      <div className="mt-6">
        <div className="mt-10">{children}</div>
      </div>
    </main>
  </div>
);

export default Page;
